import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { CompanySettingsProvider } from '@/contexts/CompanySettingsContext';
import { PermissionsProvider } from '@/contexts/PermissionsContext';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/components/auth/Login';
import DashboardLayout from '@/components/layout/DashboardLayout';
import RoleDashboard from '@/components/dashboard/RoleDashboard';
import CustomerManagement from '@/components/customers/CustomerManagement';
import InventoryManagement from '@/components/inventory/InventoryManagement';
import UserManagement from '@/components/users/UserManagement';
import InstallmentManagement from '@/components/installments/InstallmentManagement';
import LockUnlockManagement from '@/components/lockunlock/LockUnlockManagement';
import CustomerApprovals from '@/components/customers/CustomerApprovals';
import CommissionDashboard from '@/components/commission/CommissionDashboard';
import HRPayrollManagement from '@/components/payroll/HRPayrollManagement';
import CompanySettings from '@/components/settings/CompanySettings';
import InstallmentPlanMaster from '@/components/settings/InstallmentPlanMaster';
import FinanceModule from '@/components/finance/FinanceModule';
import ReportsCenter from '@/components/reports/ReportsCenter';
import PerformanceCenter from '@/components/performance/PerformanceCenter';
import WhatsAppIntegration from '@/components/whatsapp/WhatsAppIntegration';
import WhatsAppReminders from '@/components/whatsapp/WhatsAppReminders';
import BranchManagement from '@/components/branches/BranchManagement';
import AuditLogViewer from '@/components/audit/AuditLogViewer';
import InvestorsManagement from '@/components/investors/InvestorsManagement';
import PayrollManagement from '@/components/payroll/PayrollManagement';
import PrinterSetup from '@/components/settings/PrinterSetup';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-950"><div className="text-white">Loading...</div></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function DashboardRouter() {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<RoleDashboard />} />
        <Route path="dashboard" element={<RoleDashboard />} />
        <Route path="customers" element={<CustomerManagement />} />
        <Route path="customer-approvals" element={<CustomerApprovals />} />
        <Route path="commissions" element={<CommissionDashboard />} />
        <Route path="hr-payroll" element={<HRPayrollManagement />} />
        <Route path="inventory" element={<InventoryManagement />} />
        <Route path="installments" element={<InstallmentManagement />} />
        <Route path="installment-plans" element={<InstallmentPlanMaster />} />
        <Route path="agreements" element={<InstallmentManagement />} />
        <Route path="finance" element={<FinanceModule />} />
        <Route path="lock-unlock" element={<LockUnlockManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="branches" element={<BranchManagement />} />
        <Route path="settings" element={<CompanySettings />} />
        <Route path="settings/printers" element={<PrinterSetup />} />
        <Route path="printers" element={<PrinterSetup />} />
        <Route path="reports" element={<ReportsCenter />} />
        <Route path="performance" element={<PerformanceCenter />} />
        <Route path="whatsapp-integration" element={<WhatsAppIntegration />} />
        <Route path="whatsapp-reminders" element={<WhatsAppReminders />} />
        <Route path="whatsapp" element={<WhatsAppReminders />} />
        <Route path="audit-logs" element={<AuditLogViewer />} />
        <Route path="investors" element={<InvestorsManagement />} />
        <Route path="payroll" element={<PayrollManagement />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <CompanySettingsProvider>
      <AuthProvider>
        <PermissionsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={<ProtectedRoute><DashboardRouter /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </PermissionsProvider>
      </AuthProvider>
    </CompanySettingsProvider>
  );
}

export default App;
